<template>
  <div class="profit-bonus-page">
    <div class="page-head">
      <div class="title-wrap">
        <span class="title-bar"></span>
        <span class="page-title">盈加码活动</span>
      </div>
      <el-button
        v-if="activeTab === 'task' && canAddTask"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="openAddTask"
      >
        新增任务
      </el-button>
    </div>

    <el-tabs v-model="activeTab" class="activity-tabs" @tab-click="onTabClick">
      <el-tab-pane
        v-for="tab in visibleTabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      ></el-tab-pane>
    </el-tabs>

    <template v-if="activeTab === 'management'">
      <el-form :inline="true" :model="query" size="small" class="query-form management-query-form">
        <el-form-item>
          <el-input v-model.trim="query.activityId" clearable placeholder="活动ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="query.activityName" clearable placeholder="活动名称" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.status" clearable placeholder="全部状态">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.timeRange"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
        <el-form-item v-if="canAdd" class="management-add-item">
          <el-tooltip :disabled="!addDisabledReason" :content="addDisabledReason" placement="top">
            <span class="add-button-wrap">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                :disabled="!!addDisabledReason"
                @click="openAdd"
              >
                新增活动
              </el-button>
            </span>
          </el-tooltip>
        </el-form-item>
      </el-form>

      <el-table key="profit-bonus-management-table" :data="rows" border size="small" class="activity-table">
        <el-table-column prop="id" label="活动ID" width="90" align="center" />
        <el-table-column prop="activityName" label="活动名称" min-width="150" />
        <el-table-column label="活动时间" min-width="190">
          <template slot-scope="scope">
            <div>{{ formatTime(scope.row.startTime) }}</div>
            <div>{{ formatTime(scope.row.endTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="activityUserTypeName" label="用户类别" min-width="110" />
        <el-table-column prop="participationTypeName" label="参与方式" width="90" align="center" />
        <el-table-column prop="settlementTypeName" label="结算方式" width="90" align="center" />
        <el-table-column prop="settlementCycleName" label="结算周期" width="90" align="center" />
        <el-table-column label="已用额度" width="120" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.usedQuota) }}</template>
        </el-table-column>
        <el-table-column label="美化额度" width="120" align="right">
          <template slot-scope="scope">
            <el-button v-if="canQuotaBeautifyRecords" type="text" size="small" @click="$refs.quotaBeautify.openRecords(scope.row)">
              {{ amountText(scope.row.beautifyQuota == null ? 0 : scope.row.beautifyQuota) }}
            </el-button>
            <span v-else>{{ amountText(scope.row.beautifyQuota == null ? 0 : scope.row.beautifyQuota) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总额度" width="120" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.totalQuota) }}</template>
        </el-table-column>
        <el-table-column prop="symbolScopeName" label="支持币对" width="95" align="center" />
        <el-table-column prop="bonusTypeName" label="加成方式" width="95" align="center" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="mini">{{ scope.row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="活动地址" min-width="170">
          <template slot-scope="scope">
            <span class="link-text">{{ scope.row.activityAddress }}</span>
            <el-button
              v-if="scope.row.activityAddress"
              type="text"
              size="mini"
              icon="el-icon-document-copy"
              @click="copyLink(scope.row.activityAddress)"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="250" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button v-if="canAdd" type="text" size="small" @click="openCopy(scope.row)">复制</el-button>
            <el-button v-if="canEdit && scope.row.status === 0" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-if="canToggle && scope.row.status === 1" type="text" size="small" class="danger-text" @click="toggleStatus(scope.row, 2)">暂停</el-button>
            <el-button v-if="canToggle && scope.row.status === 2" type="text" size="small" @click="toggleStatus(scope.row, 1)">启用</el-button>
            <el-button v-if="canQuotaBeautify" type="text" size="small" @click="$refs.quotaBeautify.openConfig(scope.row)">额度美化</el-button>
            <div v-if="(scope.row.status === 0 && canStartNow) || (scope.row.status === 1 && (canEndNow || canRunNow))" class="manual-activity-actions">
              <el-button v-if="scope.row.status === 0 && canStartNow" type="text" size="small"
                :disabled="manualActionId !== null" :loading="manualActionId === scope.row.id && manualAction === 'startNow'"
                @click="manualActivityAction(scope.row, 'startNow')">立即开启</el-button>
              <el-button v-if="scope.row.status === 1 && canEndNow" type="text" size="small" class="danger-text"
                :disabled="manualActionId !== null" :loading="manualActionId === scope.row.id && manualAction === 'endNow'"
                @click="manualActivityAction(scope.row, 'endNow')">立即结束</el-button>
              <el-button v-if="scope.row.status === 1 && canRunNow" type="text" size="small"
                :disabled="manualActionId !== null" :loading="manualActionId === scope.row.id && manualAction === 'runNow'"
                @click="manualActivityAction(scope.row, 'runNow')">立即跑批</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </template>

    <template v-else-if="activeTab === 'task'">
      <el-form :inline="true" :model="taskQuery" size="small" class="query-form">
        <el-form-item>
          <el-input v-model.trim="taskQuery.taskId" clearable placeholder="任务ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="taskQuery.taskName" clearable placeholder="任务名称" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="taskQuery.profitBonusActivityName" clearable placeholder="关联活动名称" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="taskQuery.status" clearable placeholder="全部任务状态">
            <el-option v-for="item in taskStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchTask">查询</el-button>
          <el-button @click="resetTaskQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table key="profit-bonus-task-table" :data="taskRows" border size="small" class="activity-table">
        <el-table-column prop="id" label="任务ID" width="90" align="center" />
        <el-table-column prop="taskName" label="任务名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="profitBonusActivityName" label="关联活动名称" min-width="170" show-overflow-tooltip />
        <el-table-column prop="taskTypeName" label="任务类型" width="120" align="center" />
        <el-table-column label="任务时间" min-width="190">
          <template slot-scope="scope">
            <div>{{ formatTime(scope.row.startTime) }}</div>
            <div>{{ formatTime(scope.row.endTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="任务状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="taskStatusTagType(scope.row.status)" size="mini">{{ scope.row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openTaskDetail(scope.row)">详情</el-button>
            <el-button v-if="canEditTask && scope.row.status === 0" type="text" size="small" @click="openTaskEdit(scope.row)">修改</el-button>
            <el-button v-if="showTaskTradeData(scope.row)" type="text" size="small" @click="openTaskTradeData(scope.row)">交易数据</el-button>
            <el-button v-if="showTaskInviteRecords(scope.row)" type="text" size="small" @click="openTaskInviteRecords(scope.row)">邀请记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="taskTotal"
        :page-size="taskPageSize"
        :current-page.sync="taskPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onTaskSizeChange"
        @current-change="fetchTaskList"
      />
    </template>

    <template v-else-if="activeTab === 'invite'">
      <el-form :inline="true" :model="inviteQuery" size="small" class="query-form">
        <el-form-item>
          <el-input v-model.trim="inviteQuery.userId" clearable placeholder="用户UID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="inviteQuery.isPartner" clearable placeholder="是否合伙人">
            <el-option v-for="item in isPartnerOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="inviteQuery.partnerUid" clearable placeholder="合伙人UID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="inviteQuery.activityName" clearable placeholder="活动名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchInvite">查询</el-button>
          <el-button @click="resetInviteQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table key="profit-bonus-invite-table" :data="inviteRows" border size="small" class="activity-table" v-loading="inviteLoading">
        <el-table-column prop="userId" label="用户UID" width="110" align="center" />
        <el-table-column label="是否合伙人" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.isPartner === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="合伙人UID" width="120" align="center">
          <template slot-scope="scope">{{ scope.row.partnerUid || '--' }}</template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="170" show-overflow-tooltip />
        <el-table-column prop="inviteCount" label="邀请人数" width="100" align="right" />
        <el-table-column prop="validInviteCount" label="有效邀请人数" width="120" align="right" />
        <el-table-column label="获得加成比例" width="130" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.bonusRate) }}</template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updatedTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="canInviteRecord" type="text" size="small" @click="openInviteRecords(scope.row)">邀请记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="inviteTotal"
        :page-size="invitePageSize"
        :current-page.sync="invitePage"
        :page-sizes="[20, 50, 100]"
        @size-change="onInviteSizeChange"
        @current-change="fetchInviteList"
      />
    </template>

    <template v-else-if="activeTab === 'reward'">
      <el-form :inline="true" :model="rewardQuery" size="small" class="query-form reward-query-form">
        <el-form-item>
          <el-input v-model.trim="rewardQuery.userId" clearable placeholder="用户UID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="rewardQuery.isPartner" clearable placeholder="是否合伙人">
            <el-option v-for="item in isPartnerOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="rewardQuery.partnerUid" clearable placeholder="合伙人UID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="rewardQuery.profitBonusActivityId" clearable placeholder="活动ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="rewardQuery.activityName" clearable placeholder="活动名称" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="rewardQuery.positionId" clearable placeholder="仓位ID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="rewardQuery.status" clearable placeholder="全部发放状态">
            <el-option v-for="item in rewardStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="发放时间：">
          <el-date-picker v-model="rewardQuery.grantDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchReward">查询</el-button>
          <el-button @click="resetRewardQuery">重置</el-button>
          <el-button
            v-if="canRewardExport"
            :loading="rewardExportLoading"
            @click="exportRewards"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>

      <el-table key="profit-bonus-reward-table" :data="rewardRows" border size="small" class="activity-table reward-table" v-loading="rewardLoading">
        <el-table-column prop="userId" label="用户UID" width="105" align="center" />
        <el-table-column label="是否合伙人" width="95" align="center">
          <template slot-scope="scope">{{ scope.row.isPartner === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="合伙人UID" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.partnerUid || '--' }}</template>
        </el-table-column>
        <el-table-column prop="profitBonusActivityId" label="活动ID" width="95" align="center" />
        <el-table-column prop="activityName" label="活动名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="positionId" label="仓位ID" width="150" align="center" />
        <el-table-column label="平仓时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.closeTime) }}</template>
        </el-table-column>
        <el-table-column label="平仓盈利" min-width="130" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.closeProfit) }}</template>
        </el-table-column>
        <el-table-column label="加成比例" width="100" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.bonusRate) }}</template>
        </el-table-column>
        <el-table-column label="预计加成奖励" min-width="130" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.estimatedReward) }}</template>
        </el-table-column>
        <el-table-column label="实际加成奖励" min-width="130" align="right">
          <template slot-scope="scope">{{ actualRewardText(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="grantTypeName" label="发放方式" width="100" align="center" />
        <el-table-column label="发放状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.failReason" :content="scope.row.failReason" placement="top">
              <el-tag :type="rewardStatusTagType(scope.row.status)" size="mini">{{ scope.row.statusName }}</el-tag>
            </el-tooltip>
            <el-tag v-else :type="rewardStatusTagType(scope.row.status)" size="mini">{{ scope.row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditBy" label="审批人" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.auditBy || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="发放时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.grantTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="155" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="canRewardAudit && scope.row.status === 1" type="text" size="small" @click="auditReward(scope.row, true)">审核通过</el-button>
            <el-button v-if="canRewardAudit && scope.row.status === 1" type="text" size="small" class="danger-text" @click="auditReward(scope.row, false)">审核拒绝</el-button>
            <el-button v-if="canRewardRegrant && scope.row.status === 5" type="text" size="small" @click="regrantReward(scope.row)">重新发放</el-button>
            <span v-if="!showRewardActions(scope.row)" class="empty-action">--</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="rewardTotal"
        :page-size="rewardPageSize"
        :current-page.sync="rewardPage"
        :page-sizes="[20, 50, 100]"
        @size-change="onRewardSizeChange"
        @current-change="fetchRewardList"
      />
    </template>

    <template v-else-if="activeTab === 'stats'">
      <el-form :inline="true" :model="statsQuery" size="small" class="query-form stats-query-form">
        <el-form-item class="stats-input-item">
          <el-input v-model.trim="statsQuery.userId" clearable placeholder="用户UID" />
        </el-form-item>
        <el-form-item class="stats-input-item">
          <el-input v-model.trim="statsQuery.partnerUid" clearable placeholder="合伙人UID" />
        </el-form-item>
        <el-form-item class="stats-input-item">
          <el-input v-model.trim="statsQuery.activityName" clearable placeholder="活动名称" />
        </el-form-item>
        <el-form-item class="stats-select-item">
          <el-select v-model="statsQuery.isPartner" clearable placeholder="是否合伙人">
            <el-option v-for="item in isPartnerOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item class="stats-select-item">
          <el-select v-model="statsQuery.bonusLevel" clearable placeholder="全部加成等级">
            <el-option v-for="item in bonusLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item class="stats-time-item">
          <el-date-picker
            v-model="statsQuery.timeRange"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item class="stats-action-item">
          <el-button type="primary" @click="searchStats">查询</el-button>
          <el-button @click="resetStatsQuery">重置</el-button>
          <el-button :loading="statsExporting" @click="exportStats">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        key="profit-bonus-statistics-table"
        :data="statsRows"
        border
        size="small"
        class="activity-table stats-table"
        v-loading="statsLoading"
        @sort-change="onStatsSortChange"
      >
        <el-table-column prop="userId" label="用户UID" width="105" align="center" />
        <el-table-column label="是否合伙人" width="95" align="center">
          <template slot-scope="scope">{{ scope.row.isPartner === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="合伙人UID" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.partnerUid || '--' }}</template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="当前VIP等级" width="115" align="center">
          <template slot-scope="scope">{{ vipText(scope.row.currentVipLevel) }}</template>
        </el-table-column>
        <el-table-column label="近N天交易量" min-width="185" align="right">
          <template slot-scope="scope">{{ statisticAmountText(scope.row.tradeAmount, scope.row.tradeStatCycle) }}</template>
        </el-table-column>
        <el-table-column label="近N天平均账户资产" min-width="185" align="right">
          <template slot-scope="scope">{{ statisticAmountText(scope.row.averageAsset, scope.row.assetStatCycle) }}</template>
        </el-table-column>
        <el-table-column label="达标门槛" min-width="230" align="center">
          <template slot-scope="scope">
            <div class="matched-threshold">{{ matchedThresholdText(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="bonusLevel" label="加成等级" width="105" align="center" sortable="custom">
          <template slot-scope="scope">{{ levelText(scope.row.bonusLevel) }}</template>
        </el-table-column>
        <el-table-column prop="availableQuota" label="可用额度" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">{{ amountText(scope.row.availableQuota) }}</template>
        </el-table-column>
        <el-table-column prop="userTotalQuota" label="总额度" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">{{ amountText(scope.row.userTotalQuota) }}</template>
        </el-table-column>
        <el-table-column prop="todayReward" label="当天获得加成奖励" min-width="145" align="right" sortable="custom">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openRewardStatisticRecords(scope.row, true)">
              {{ amountText(scope.row.todayReward) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="totalReward" label="累计获得加成奖励" min-width="145" align="right" sortable="custom">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openRewardStatisticRecords(scope.row, false)">
              {{ amountText(scope.row.totalReward) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="baseBonusRate" label="基础加成比例" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openBaseRateRecords(scope.row)">
              {{ percentText(scope.row.baseBonusRate) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="taskBonusRate" label="任务加成比例" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openTaskRateRecords(scope.row)">
              {{ percentText(scope.row.taskBonusRate) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="totalBonusRate" label="总加成比例" min-width="110" align="right" sortable="custom">
          <template slot-scope="scope">{{ percentText(scope.row.totalBonusRate) }}</template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updatedTime) }}</template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="statsTotal"
        :page-size="statsPageSize"
        :current-page.sync="statsPage"
        :page-sizes="[20, 50, 100]"
        @size-change="onStatsSizeChange"
        @current-change="fetchStatsList"
      />
    </template>

    <quota-beautify-dialog ref="quotaBeautify" :format-time="formatTime" :amount-text="amountText" @saved="fetchList" />

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1180px"
      top="4vh"
      class="profit-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div class="section-title"><span></span>基本信息</div>
        <el-form :model="form" label-position="top" size="small" class="activity-form">
          <div class="form-grid two">
            <el-form-item label="活动名称" :required="!isDetail" :error="fieldError('activityName')">
              <el-input
                v-model.trim="form.activityName"
                :disabled="isDetail"
                maxlength="50"
                clearable
                placeholder="请输入活动名称"
              />
            </el-form-item>
            <el-form-item label="用户类别" :required="!isDetail" :error="fieldError('welfareUserTypeId')">
              <el-select v-model="form.welfareUserTypeId" :disabled="isDetail" filterable placeholder="请选择用户类别">
                <el-option v-for="item in userTypeOptions" :key="item.id" :label="item.typeName" :value="item.id" />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="支持币对" :required="!isDetail" :error="fieldError('symbolScope')">
            <el-radio-group v-model="form.symbolScope" :disabled="isDetail">
              <el-radio label="ALL">全部币对</el-radio>
              <el-radio label="PART">部分币对</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.symbolScope === 'PART'" label="币对选择" :required="!isDetail" :error="fieldError('symbolIds')">
            <el-select
              v-model="form.symbolIds"
              :disabled="isDetail"
              multiple
              filterable
              class="symbol-select"
              placeholder="请选择币对"
            >
              <el-option v-for="item in symbolOptions" :key="item.id" :label="item.symbol" :value="item.id" />
            </el-select>
          </el-form-item>
          <div class="form-grid two">
            <el-form-item label="参与方式" :required="!isDetail">
              <el-select v-model="form.participationType" disabled>
                <el-option label="自动参与" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="活动时间" :required="!isDetail" :error="fieldError('timeRange')">
              <el-input v-if="isDetail" :value="detailTimeRangeText" disabled />
              <el-date-picker
                v-else
                v-model="form.timeRange"
                :disabled="isDetail"
                :picker-options="activityPickerOptions"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </div>

          <div class="section-title"><span></span>奖励规则</div>
          <div class="form-grid three">
            <el-form-item label="总额度" :required="!isDetail" :error="fieldError('totalQuota')">
              <el-input
                v-model.trim="form.totalQuota"
                :disabled="isDetail"
                maxlength="15"
                placeholder="请输入总额度"
                @input="onFormIntegerInput('totalQuota', $event, 15)"
              >
                <template slot="append">USDT</template>
              </el-input>
            </el-form-item>
            <el-form-item label="结算方式" :required="!isDetail">
              <el-select v-model="form.settlementType" disabled>
                <el-option label="平仓结算" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="结算周期" :required="!isDetail">
              <el-select v-model="form.settlementCycle" disabled>
                <el-option label="实时结算" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="奖励审核门槛" :required="!isDetail" :error="fieldError('approvalThreshold')">
              <el-input
                v-model.trim="form.approvalThreshold"
                :disabled="isDetail"
                maxlength="10"
                placeholder="请输入奖励审核门槛"
                @input="onFormIntegerInput('approvalThreshold', $event, 10)"
              >
                <template slot="append">USDT</template>
              </el-input>
            </el-form-item>
          </div>

          <div class="section-title"><span></span>加成方式</div>
          <div class="form-grid three">
            <el-form-item label="加成方式" :required="!isDetail">
              <el-select v-model="form.bonusType" disabled>
                <el-option label="加成等级" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="账户资产统计区间" :required="!isDetail" :error="fieldError('assetStatCycle')">
              <el-select v-model="form.assetStatCycle" :disabled="isDetail" placeholder="请选择账户资产统计区间">
                <el-option v-for="item in statCycleOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="交易统计区间" :required="!isDetail" :error="fieldError('tradeStatCycle')">
              <el-select v-model="form.tradeStatCycle" :disabled="isDetail" placeholder="请选择交易统计区间">
                <el-option v-for="item in statCycleOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </div>

          <div class="level-head">
            <div class="section-title level-title"><span></span>加成等级配置</div>
            <el-button
              v-if="!isDetail"
              type="primary"
              plain
              size="small"
              icon="el-icon-plus"
              @click="addLevel"
            >
              新增加成等级
            </el-button>
          </div>
          <el-table :data="form.levels" border size="small" class="level-table">
            <el-table-column prop="bonusLevel" label="加成等级" width="72" align="center" />
            <el-table-column label="VIP等级区间" min-width="186" align="center">
              <template slot-scope="scope">
                <el-form-item class="level-form-item" :error="levelFieldError(scope.$index, 'vipLevel')">
                  <div class="vip-range">
                    <el-select
                      v-model="scope.row.vipLevelMin"
                      disabled
                      size="mini"
                    >
                      <el-option v-for="item in vipLevels" :key="item.code" :label="item.label" :value="Number(item.code)" />
                    </el-select>
                    <span>至</span>
                    <el-select
                      v-model="scope.row.vipLevelMax"
                      :disabled="isDetail"
                      size="mini"
                      @change="syncVipRanges(scope.$index)"
                    >
                      <el-option
                        v-for="item in levelEndOptions(scope.row)"
                        :key="item.code"
                        :label="item.label"
                        :value="Number(item.code)"
                      />
                    </el-select>
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="账户资产门槛" min-width="158" align="center">
              <template slot-scope="scope">
                <el-form-item class="level-form-item" :error="levelFieldError(scope.$index, 'assetThreshold')">
                  <el-input
                    v-model.trim="scope.row.assetThreshold"
                    :disabled="isDetail"
                    size="mini"
                    maxlength="15"
                    class="unit-input"
                    placeholder="请输入"
                    @input="onLevelIntegerInput(scope.row, 'assetThreshold', $event, 15)"
                  >
                    <template slot="append">USDT</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="交易量门槛" min-width="158" align="center">
              <template slot-scope="scope">
                <el-form-item class="level-form-item" :error="levelFieldError(scope.$index, 'tradeThreshold')">
                  <el-input
                    v-model.trim="scope.row.tradeThreshold"
                    :disabled="isDetail"
                    size="mini"
                    maxlength="15"
                    class="unit-input"
                    placeholder="请输入"
                    @input="onLevelIntegerInput(scope.row, 'tradeThreshold', $event, 15)"
                  >
                    <template slot="append">USDT</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="加成比例" min-width="104" align="center">
              <template slot-scope="scope">
                <el-form-item class="level-form-item" :error="levelFieldError(scope.$index, 'bonusRate')">
                  <el-input
                    v-model.trim="scope.row.bonusRate"
                    :disabled="isDetail"
                    size="mini"
                    class="rate-input"
                    placeholder="0.00"
                    @input="onLevelDecimalInput(scope.row, 'bonusRate', $event, 2)"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="额度周期" width="88" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.quotaCycle" disabled size="mini">
                  <el-option label="每日" :value="1" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="额度数值" min-width="158" align="center">
              <template slot-scope="scope">
                <el-form-item class="level-form-item" :error="levelFieldError(scope.$index, 'quota')">
                  <el-input
                    v-model.trim="scope.row.quota"
                    :disabled="isDetail"
                    size="mini"
                    maxlength="15"
                    class="unit-input"
                    placeholder="请输入额度"
                    @input="onLevelIntegerInput(scope.row, 'quota', $event, 15)"
                  >
                    <template slot="append">USDT</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column v-if="!isDetail" label="操作" width="62" align="center">
              <template slot-scope="scope">
                <el-button :disabled="scope.$index === 0" type="text" size="small" @click="removeLevel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="!isDetail" class="form-hint">加成等级从0开始，每新增一条自动+1</div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{ isDetail ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isDetail" type="primary" size="small" :disabled="submitting" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <TaskFormDialog
      v-model="taskDialogVisible"
      :mode="taskDialogMode"
      :task-id="currentTaskId"
      @success="fetchTaskList"
    />
    <el-dialog
      title="邀请记录"
      :visible.sync="inviteRecordVisible"
      width="960px"
      class="profit-dialog invite-record-dialog"
      :close-on-click-modal="false"
      @closed="resetInviteRecordState"
    >
      <el-form :inline="true" :model="inviteRecordQuery" size="small" class="query-form trade-query-form">
        <el-form-item>
          <el-input v-model.trim="inviteRecordQuery.invitedUserId" clearable placeholder="用户UID" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchInviteRecords">查询</el-button>
          <el-button @click="resetInviteRecordQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="inviteRecordRows" border size="small" class="activity-table" v-loading="inviteRecordLoading">
        <el-table-column prop="invitedUserId" label="邀请用户UID" min-width="120" align="center" />
        <el-table-column label="用户注册时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.invitedRegisterTime) }}</template>
        </el-table-column>
        <el-table-column label="首次充值时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.firstRechargeTime) }}</template>
        </el-table-column>
        <el-table-column label="充值金额" min-width="130" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.rechargeAmount) }}</template>
        </el-table-column>
        <el-table-column label="首次合约交易时间" min-width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.firstContractTradeTime) }}</template>
        </el-table-column>
        <el-table-column label="合约交易金额" min-width="140" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.contractTradeAmount) }}</template>
        </el-table-column>
        <el-table-column label="邀请状态" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="inviteStatusTagType(scope.row.validStatus)" size="mini">{{ scope.row.validStatusName || '-' }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="inviteRecordTotal"
        :page-size="inviteRecordPageSize"
        :current-page.sync="inviteRecordPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onInviteRecordSizeChange"
        @current-change="fetchInviteRecords"
      />
    </el-dialog>
    <el-dialog
      title="交易数据"
      :visible.sync="tradeDataVisible"
      width="760px"
      class="profit-dialog trade-data-dialog"
      :close-on-click-modal="false"
      @closed="resetTradeDataState"
    >
      <el-form :inline="true" :model="tradeDataQuery" size="small" class="query-form trade-query-form">
        <el-form-item>
          <el-input v-model.trim="tradeDataQuery.userId" clearable placeholder="用户UID" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchTaskTradeData">查询</el-button>
          <el-button @click="resetTaskTradeDataQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tradeDataRows" border size="small" class="activity-table" v-loading="tradeDataLoading">
        <el-table-column prop="userId" label="用户UID" min-width="130" align="center" />
        <el-table-column label="累计交易金额" min-width="180" align="right">
          <template slot-scope="scope">{{ scope.row.cumulativeTradeAmount || '-' }}</template>
        </el-table-column>
        <el-table-column label="获得加成比例" min-width="140" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.bonusRate) }}</template>
        </el-table-column>
        <el-table-column label="获取时间" min-width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.updatedTime) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="tradeDataTotal"
        :page-size="tradeDataPageSize"
        :current-page.sync="tradeDataPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onTaskTradeDataSizeChange"
        @current-change="fetchTaskTradeData"
      />
    </el-dialog>
    <el-dialog
      title="基础加成比例记录"
      :visible.sync="baseRateRecordVisible"
      width="780px"
      class="profit-dialog statistic-record-dialog"
      :close-on-click-modal="false"
      @closed="resetBaseRateRecordState"
    >
      <el-table :data="baseRateRecordRows" border size="small" class="activity-table" v-loading="baseRateRecordLoading">
        <el-table-column label="变更时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="变更前加成等级" min-width="140" align="center">
          <template slot-scope="scope">{{ levelText(scope.row.beforeLevelNo) }}</template>
        </el-table-column>
        <el-table-column label="变更前加成比例" min-width="140" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.beforeBonusRate) }}</template>
        </el-table-column>
        <el-table-column label="变更后加成等级" min-width="140" align="center">
          <template slot-scope="scope">{{ levelText(scope.row.afterLevelNo) }}</template>
        </el-table-column>
        <el-table-column label="变更后加成比例" min-width="140" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.afterBonusRate) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="baseRateRecordTotal"
        :page-size="baseRateRecordPageSize"
        :current-page.sync="baseRateRecordPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onBaseRateRecordSizeChange"
        @current-change="fetchBaseRateRecords"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="baseRateRecordVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="任务加成比例记录"
      :visible.sync="taskRateRecordVisible"
      width="680px"
      class="profit-dialog statistic-record-dialog"
      :close-on-click-modal="false"
      @closed="resetTaskRateRecordState"
    >
      <el-table :data="taskRateRecordRows" border size="small" class="activity-table" v-loading="taskRateRecordLoading">
        <el-table-column label="获得时间" min-width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="获得加成比例" min-width="150" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.bonusRate) }}</template>
        </el-table-column>
        <el-table-column label="来源任务类型" min-width="160" align="center">
          <template slot-scope="scope">{{ scope.row.taskTypeName || '--' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="taskRateRecordTotal"
        :page-size="taskRateRecordPageSize"
        :current-page.sync="taskRateRecordPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onTaskRateRecordSizeChange"
        @current-change="fetchTaskRateRecords"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="taskRateRecordVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="累计获得加成奖励记录"
      :visible.sync="rewardStatisticVisible"
      width="900px"
      class="profit-dialog statistic-reward-dialog"
      :close-on-click-modal="false"
      @closed="resetRewardStatisticState"
    >
      <el-form :inline="true" :model="rewardStatisticQuery" size="small" class="query-form trade-query-form">
        <el-form-item label="平仓时间">
          <el-date-picker
            v-model="rewardStatisticQuery.timeRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRewardStatisticRecords">查询</el-button>
          <el-button @click="resetRewardStatisticQuery">重置</el-button>
        </el-form-item>
        <div class="reward-statistic-total">累计获得加成奖励：<strong>{{ amountText(rewardStatisticTotalReward) }}</strong></div>
      </el-form>
      <el-table :data="rewardStatisticRows" border size="small" class="activity-table" v-loading="rewardStatisticLoading">
        <el-table-column label="平仓时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.closeTime) }}</template>
        </el-table-column>
        <el-table-column prop="positionId" label="仓位ID" min-width="120" align="center" />
        <el-table-column prop="symbol" label="合约币对" min-width="120" align="center" />
        <el-table-column label="平仓盈利" min-width="130" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.closeProfit) }}</template>
        </el-table-column>
        <el-table-column label="加成等级" min-width="100" align="center">
          <template slot-scope="scope">{{ levelText(scope.row.bonusLevel) }}</template>
        </el-table-column>
        <el-table-column label="加成比例" min-width="100" align="right">
          <template slot-scope="scope">{{ percentText(scope.row.bonusRate) }}</template>
        </el-table-column>
        <el-table-column label="获得加成奖励" min-width="130" align="right">
          <template slot-scope="scope">{{ amountText(scope.row.actualReward) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="rewardStatisticTotal"
        :page-size="rewardStatisticPageSize"
        :current-page.sync="rewardStatisticPage"
        :page-sizes="[10, 20, 50]"
        @size-change="onRewardStatisticSizeChange"
        @current-change="fetchRewardStatisticRecords"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="rewardStatisticVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasPerm } from 'common/permission'
import api from './api'
import TaskFormDialog from './components/TaskFormDialog.vue'
import QuotaBeautifyDialog from './components/QuotaBeautifyDialog.vue'

function defaultQuery() {
  return {
    activityId: '',
    activityName: '',
    status: '',
    timeRange: [],
  }
}

function defaultTaskQuery() {
  return {
    taskId: '',
    taskName: '',
    profitBonusActivityName: '',
    status: '',
  }
}

function defaultInviteQuery() {
  return {
    userId: '',
    isPartner: '',
    partnerUid: '',
    activityName: '',
  }
}

function defaultRewardQuery() {
  return {
    userId: '',
    isPartner: '',
    partnerUid: '',
    profitBonusActivityId: '',
    activityName: '',
    positionId: '',
    status: '',
    grantDateRange: [],
  }
}

function defaultStatsQuery() {
  return {
    userId: '',
    partnerUid: '',
    activityName: '',
    isPartner: '',
    bonusLevel: '',
    timeRange: [],
  }
}

export default {
  name: 'ProfitBonusActivity',
  components: { TaskFormDialog, QuotaBeautifyDialog },
  data() {
    return {
      activeTab: 'management',
      tabs: [
        { label: '活动管理', name: 'management', perm: 'tenant:profit_bonus_activity:tab_management' },
        { label: '活动任务', name: 'task', perm: 'tenant:profit_bonus_activity:tab_task' },
        { label: '邀请好友记录', name: 'invite', perm: 'tenant:profit_bonus_activity:tab_invite' },
        { label: '奖励发放记录', name: 'reward', perm: 'tenant:profit_bonus_activity:tab_reward' },
        { label: '活动数据统计', name: 'stats', perm: 'tenant:profit_bonus_activity:tab_stats' },
      ],
      query: defaultQuery(),
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      activityLoaded: false,
      manualActionId: null,
      manualAction: '',
      taskQuery: defaultTaskQuery(),
      taskRows: [],
      taskTotal: 0,
      taskPage: 1,
      taskPageSize: 10,
      taskLoaded: false,
      taskDialogVisible: false,
      taskDialogMode: 'add',
      currentTaskId: null,
      inviteQuery: defaultInviteQuery(),
      inviteRows: [],
      inviteTotal: 0,
      invitePage: 1,
      invitePageSize: 20,
      inviteLoaded: false,
      inviteLoading: false,
      rewardQuery: defaultRewardQuery(),
      rewardRows: [],
      rewardTotal: 0,
      rewardPage: 1,
      rewardPageSize: 20,
      rewardLoaded: false,
      rewardLoading: false,
      rewardExportLoading: false,
      statsQuery: defaultStatsQuery(),
      statsRows: [],
      statsTotal: 0,
      statsPage: 1,
      statsPageSize: 20,
      statsLoaded: false,
      statsLoading: false,
      statsExporting: false,
      statsSortField: '',
      statsSortOrder: '',
      inviteRecordVisible: false,
      inviteRecordLoading: false,
      currentInviteSummary: null,
      inviteRecordQuery: {
        invitedUserId: '',
      },
      inviteRecordRows: [],
      inviteRecordTotal: 0,
      inviteRecordPage: 1,
      inviteRecordPageSize: 10,
      tradeDataVisible: false,
      tradeDataLoading: false,
      currentTradeTask: null,
      tradeDataQuery: {
        userId: '',
      },
      tradeDataRows: [],
      tradeDataTotal: 0,
      tradeDataPage: 1,
      tradeDataPageSize: 10,
      currentStatsRow: null,
      baseRateRecordVisible: false,
      baseRateRecordLoading: false,
      baseRateRecordRows: [],
      baseRateRecordTotal: 0,
      baseRateRecordPage: 1,
      baseRateRecordPageSize: 10,
      taskRateRecordVisible: false,
      taskRateRecordLoading: false,
      taskRateRecordRows: [],
      taskRateRecordTotal: 0,
      taskRateRecordPage: 1,
      taskRateRecordPageSize: 10,
      rewardStatisticVisible: false,
      rewardStatisticLoading: false,
      rewardStatisticQuery: {
        timeRange: [],
      },
      rewardStatisticRows: [],
      rewardStatisticTotal: 0,
      rewardStatisticTotalReward: 0,
      rewardStatisticPage: 1,
      rewardStatisticPageSize: 10,
      dialogVisible: false,
      dialogMode: 'add',
      submitting: false,
      activityShowErrors: false,
      activityLevelErrorIndexes: [],
      userTypeOptions: [],
      symbolOptions: [],
      vipLevels: [],
      form: this.defaultForm(),
      activityPickerOptions: {
        disabledDate: (time) => this.localDateText(time) < this.beijingTomorrowDateText(),
      },
      statusOptions: [
        { label: '待开始', value: 0 },
        { label: '进行中', value: 1 },
        { label: '已暂停', value: 2 },
        { label: '已结束', value: 3 },
      ],
      taskStatusOptions: [
        { label: '未开始', value: 0 },
        { label: '进行中', value: 1 },
        { label: '已结束', value: 2 },
      ],
      isPartnerOptions: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      rewardStatusOptions: [
        { label: '待审核', value: 1 },
        { label: '待发放', value: 2 },
        { label: '审核拒绝', value: 3 },
        { label: '已发放', value: 4 },
        { label: '发放失败', value: 5 },
      ],
      statCycleOptions: [
        { label: '近1天', value: 1 },
        { label: '近3天', value: 3 },
        { label: '近7天', value: 7 },
        { label: '近30天', value: 30 },
      ],
      bonusLevelOptions: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
    visibleTabs() {
      return this.tabs.filter((tab) => hasPerm(this.userInfo || {}, tab.perm))
    },
    canViewInviteTab() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:tab_invite')
    },
    canAdd() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:add')
    },
    canEdit() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:edit')
    },
    canToggle() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:toggle')
    },
    canStartNow() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:start_now')
    },
    canEndNow() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:end_now')
    },
    canRunNow() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:run_now')
    },
    canQuotaBeautify() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:quota_beautify')
    },
    canQuotaBeautifyRecords() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_activity:quota_beautify_records')
    },
    canAddTask() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_task:add')
    },
    canEditTask() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_task:edit')
    },
    canTaskTradeData() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_task:trade_data')
    },
    canTaskInviteRecord() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_task:invite_record')
    },
    canInviteRecord() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_invite:record')
    },
    canRewardAudit() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_reward:audit')
    },
    canRewardExport() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_reward:export')
    },
    canRewardRegrant() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_reward:regrant')
    },
    canRewardExport() {
      return hasPerm(this.userInfo || {}, 'tenant:profit_bonus_reward:export')
    },
    hasRunningOrPausedActivity() {
      return this.rows.some((row) => row.status === 1 || row.status === 2)
    },
    addDisabledReason() {
      return this.hasRunningOrPausedActivity ? '存在进行中或已暂停的活动，不允许新增' : ''
    },
    isDetail() {
      return this.dialogMode === 'detail'
    },
    dialogTitle() {
      if (this.dialogMode === 'edit') return '编辑活动'
      if (this.dialogMode === 'detail') return '活动详情'
      if (this.dialogMode === 'copy') return '复制活动'
      return '新增活动'
    },
    formErrors() {
      return this.collectFormErrors()
    },
    formInvalidReason() {
      return this.formErrors.first || ''
    },
    formValid() {
      return !this.formInvalidReason
    },
    detailTimeRangeText() {
      const range = this.form.timeRange || []
      if (range.length !== 2) return ''
      return `${range[0]} 00:00:00 - ${range[1]} 23:59:59`
    },
  },
  watch: {
    visibleTabs() {
      this.loadCurrentTab()
    },
  },
  created() {
    this.loadCurrentTab()
  },
  methods: {
    defaultForm() {
      return {
        id: null,
        activityName: '',
        welfareUserTypeId: '',
        symbolScope: 'ALL',
        symbolIds: [],
        participationType: 1,
        timeRange: [],
        totalQuota: '',
        settlementType: 1,
        settlementCycle: 1,
        approvalThreshold: '',
        bonusType: 1,
        assetStatCycle: '',
        tradeStatCycle: '',
        levels: [this.newLevel(0, 0)],
      }
    },
    newLevel(bonusLevel, minVip) {
      return {
        bonusLevel,
        vipLevelMin: minVip,
        vipLevelMax: minVip,
        assetThreshold: '',
        tradeThreshold: '',
        bonusRate: '',
        quotaCycle: 1,
        quota: '',
      }
    },
    async loadOptions() {
      const [userTypesRes, symbolsRes, vipEnumsRes] = await Promise.all([
        api.userTypes(),
        api.symbols(),
        api.vipEnums(),
      ])
      this.userTypeOptions = (userTypesRes && userTypesRes.data) || []
      this.symbolOptions = (symbolsRes && symbolsRes.data) || []
      const vipData = (vipEnumsRes && vipEnumsRes.data) || {}
      this.vipLevels = vipData.vipLevels || []
      if (this.form.levels.length === 1 && this.form.levels[0].vipLevelMin === 0) {
        const first = this.firstVipValue()
        this.form.levels[0].vipLevelMin = first
        this.form.levels[0].vipLevelMax = first
      }
    },
    async fetchList() {
      const params = {
        page: this.page,
        size: this.pageSize,
        activityId: this.query.activityId,
        activityName: this.query.activityName,
        status: this.query.status,
      }
      if (this.query.timeRange && this.query.timeRange.length === 2) {
        params.startTime = this.query.timeRange[0]
        params.endTime = this.query.timeRange[1]
      }
      const res = await api.page(params)
      const data = (res && res.data) || {}
      this.rows = data.items || []
      this.total = data.total || 0
      this.activityLoaded = true
    },
    search() {
      this.page = 1
      this.fetchList()
    },
    resetQuery() {
      this.query = defaultQuery()
      this.page = 1
      this.fetchList()
    },
    onSizeChange(size) {
      this.pageSize = size
      this.page = 1
      this.fetchList()
    },
    onTabClick() {
      this.loadCurrentTab()
    },
    ensureActiveTab() {
      if (this.visibleTabs.some((tab) => tab.name === this.activeTab)) {
        return this.activeTab
      }
      const firstTab = this.visibleTabs[0]
      this.activeTab = firstTab ? firstTab.name : ''
      return this.activeTab
    },
    loadCurrentTab() {
      const tab = this.ensureActiveTab()
      if (!tab) return
      if (tab === 'management') {
        this.loadOptions()
        if (!this.activityLoaded) {
          this.fetchList()
        }
      }
      if (tab === 'task' && !this.taskLoaded) {
        this.fetchTaskList()
      }
      if (tab === 'invite' && !this.inviteLoaded) {
        this.fetchInviteList()
      }
      if (tab === 'reward' && !this.rewardLoaded) {
        this.fetchRewardList()
      }
      if (tab === 'stats') {
        this.fetchBonusLevelOptions()
        if (!this.statsLoaded) {
          this.fetchStatsList()
        }
      }
    },
    async fetchTaskList() {
      const params = this.buildTaskQuery()
      if (!params) return
      const res = await api.taskPage(params)
      const data = (res && res.data) || {}
      this.taskRows = data.items || []
      this.taskTotal = data.total || 0
      this.taskLoaded = true
    },
    buildTaskQuery() {
      if (this.taskQuery.taskId && !/^\d+$/.test(String(this.taskQuery.taskId))) {
        this.$message.error('任务ID仅支持数字')
        return null
      }
      return {
        page: this.taskPage,
        size: this.taskPageSize,
        taskId: this.taskQuery.taskId,
        taskName: this.taskQuery.taskName,
        profitBonusActivityName: this.taskQuery.profitBonusActivityName,
        status: this.taskQuery.status,
      }
    },
    searchTask() {
      this.taskPage = 1
      this.fetchTaskList()
    },
    resetTaskQuery() {
      this.taskQuery = defaultTaskQuery()
      this.taskPage = 1
      this.fetchTaskList()
    },
    onTaskSizeChange(size) {
      this.taskPageSize = size
      this.taskPage = 1
      this.fetchTaskList()
    },
    openAddTask() {
      this.taskDialogMode = 'add'
      this.currentTaskId = null
      this.taskDialogVisible = true
    },
    openTaskDetail(row) {
      this.taskDialogMode = 'detail'
      this.currentTaskId = row.id
      this.taskDialogVisible = true
    },
    openTaskEdit(row) {
      this.taskDialogMode = 'edit'
      this.currentTaskId = row.id
      this.taskDialogVisible = true
    },
    showTaskTradeData(row) {
      return this.canTaskTradeData && row && row.taskType === 1 && (row.status === 1 || row.status === 2)
    },
    showTaskInviteRecords(row) {
      return this.canTaskInviteRecord && this.canViewInviteTab && row && row.taskType === 2
    },
    openTaskInviteRecords(row) {
      this.activeTab = 'invite'
      this.inviteQuery = defaultInviteQuery()
      this.inviteQuery.activityName = row.profitBonusActivityName || ''
      this.invitePage = 1
      this.fetchInviteList()
    },
    openTaskTradeData(row) {
      this.currentTradeTask = row
      this.tradeDataVisible = true
      this.tradeDataQuery.userId = ''
      this.tradeDataPage = 1
      this.fetchTaskTradeData()
    },
    async fetchTaskTradeData() {
      if (!this.currentTradeTask || !this.currentTradeTask.id) return
      if (this.tradeDataQuery.userId && !/^\d+$/.test(String(this.tradeDataQuery.userId))) {
        this.$message.error('用户UID仅支持数字')
        return
      }
      this.tradeDataLoading = true
      try {
        const res = await api.taskTradeDataPage({
          taskId: this.currentTradeTask.id,
          userId: this.tradeDataQuery.userId,
          page: this.tradeDataPage,
          size: this.tradeDataPageSize,
        })
        const data = (res && res.data) || {}
        this.tradeDataRows = data.items || []
        this.tradeDataTotal = data.total || 0
      } finally {
        this.tradeDataLoading = false
      }
    },
    searchTaskTradeData() {
      this.tradeDataPage = 1
      this.fetchTaskTradeData()
    },
    resetTaskTradeDataQuery() {
      this.tradeDataQuery.userId = ''
      this.tradeDataPage = 1
      this.fetchTaskTradeData()
    },
    onTaskTradeDataSizeChange(size) {
      this.tradeDataPageSize = size
      this.tradeDataPage = 1
      this.fetchTaskTradeData()
    },
    resetTradeDataState() {
      this.currentTradeTask = null
      this.tradeDataQuery.userId = ''
      this.tradeDataRows = []
      this.tradeDataTotal = 0
      this.tradeDataPage = 1
    },
    buildInviteQuery() {
      if (this.inviteQuery.userId && !/^\d+$/.test(String(this.inviteQuery.userId))) {
        this.$message.error('用户UID仅支持数字')
        return null
      }
      if (this.inviteQuery.partnerUid && !/^\d+$/.test(String(this.inviteQuery.partnerUid))) {
        this.$message.error('合伙人UID仅支持数字')
        return null
      }
      return {
        page: this.invitePage,
        size: this.invitePageSize,
        userId: this.inviteQuery.userId,
        isPartner: this.inviteQuery.isPartner,
        partnerUid: this.inviteQuery.partnerUid,
        activityName: this.inviteQuery.activityName,
      }
    },
    async fetchInviteList() {
      const params = this.buildInviteQuery()
      if (!params) return
      this.inviteLoading = true
      try {
        const res = await api.invitePage(params)
        const data = (res && res.data) || {}
        this.inviteRows = data.items || []
        this.inviteTotal = data.total || 0
        this.inviteLoaded = true
      } finally {
        this.inviteLoading = false
      }
    },
    searchInvite() {
      this.invitePage = 1
      this.fetchInviteList()
    },
    resetInviteQuery() {
      this.inviteQuery = defaultInviteQuery()
      this.invitePage = 1
      this.fetchInviteList()
    },
    onInviteSizeChange(size) {
      this.invitePageSize = size
      this.invitePage = 1
      this.fetchInviteList()
    },
    openInviteRecords(row) {
      this.currentInviteSummary = row
      this.inviteRecordVisible = true
      this.inviteRecordQuery.invitedUserId = ''
      this.inviteRecordPage = 1
      this.fetchInviteRecords()
    },
    async fetchInviteRecords() {
      if (!this.currentInviteSummary) return
      if (this.inviteRecordQuery.invitedUserId && !/^\d+$/.test(String(this.inviteRecordQuery.invitedUserId))) {
        this.$message.error('用户UID仅支持数字')
        return
      }
      this.inviteRecordLoading = true
      try {
        const res = await api.inviteRecordsPage({
          taskId: this.currentInviteSummary.profitBonusActivityTaskId,
          userId: this.currentInviteSummary.userId,
          invitedUserId: this.inviteRecordQuery.invitedUserId,
          page: this.inviteRecordPage,
          size: this.inviteRecordPageSize,
        })
        const data = (res && res.data) || {}
        this.inviteRecordRows = data.items || []
        this.inviteRecordTotal = data.total || 0
      } finally {
        this.inviteRecordLoading = false
      }
    },
    searchInviteRecords() {
      this.inviteRecordPage = 1
      this.fetchInviteRecords()
    },
    resetInviteRecordQuery() {
      this.inviteRecordQuery.invitedUserId = ''
      this.inviteRecordPage = 1
      this.fetchInviteRecords()
    },
    onInviteRecordSizeChange(size) {
      this.inviteRecordPageSize = size
      this.inviteRecordPage = 1
      this.fetchInviteRecords()
    },
    resetInviteRecordState() {
      this.currentInviteSummary = null
      this.inviteRecordQuery.invitedUserId = ''
      this.inviteRecordRows = []
      this.inviteRecordTotal = 0
      this.inviteRecordPage = 1
    },
    buildRewardQuery() {
      const numericFields = [
        ['userId', '用户UID'],
        ['partnerUid', '合伙人UID'],
        ['profitBonusActivityId', '活动ID'],
        ['positionId', '仓位ID'],
      ]
      for (const [field, label] of numericFields) {
        if (this.rewardQuery[field] && !/^\d+$/.test(String(this.rewardQuery[field]))) {
          this.$message.error(`${label}仅支持数字`)
          return null
        }
      }
      return {
        page: this.rewardPage,
        size: this.rewardPageSize,
        userId: this.rewardQuery.userId,
        isPartner: this.rewardQuery.isPartner,
        partnerUid: this.rewardQuery.partnerUid,
        profitBonusActivityId: this.rewardQuery.profitBonusActivityId,
        activityName: this.rewardQuery.activityName,
        positionId: this.rewardQuery.positionId,
        status: this.rewardQuery.status,
        grantStartDate: this.rewardQuery.grantDateRange && this.rewardQuery.grantDateRange[0],
        grantEndDate: this.rewardQuery.grantDateRange && this.rewardQuery.grantDateRange[1],
      }
    },
    async exportRewards() {
      if (!this.canRewardExport || this.rewardExportLoading) return
      const params = this.buildRewardQuery()
      if (!params) return
      delete params.page
      delete params.size
      this.rewardExportLoading = true
      let url
      try {
        const blob = await api.rewardExport(params)
        if (!(blob instanceof Blob)) throw new Error('导出失败，请重试')
        if (blob.type.includes('json')) {
          const error = JSON.parse(await blob.text())
          throw new Error(error.msg || error.message || '导出失败，请重试')
        }
        if (!blob.size || !blob.type.includes('spreadsheetml')) throw new Error('导出文件无效，请重试')
        url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `奖励发放记录${this.formatTime(Date.now()).replace(/[- :]/g, '')}.xlsx`
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        this.$message.error((error && error.message) || '导出失败，请重试')
      } finally {
        if (url) URL.revokeObjectURL(url)
        this.rewardExportLoading = false
      }
    },
    async fetchRewardList() {
      const params = this.buildRewardQuery()
      if (!params) return
      this.rewardLoading = true
      try {
        const res = await api.rewardPage(params)
        const data = (res && res.data) || {}
        this.rewardRows = data.items || []
        this.rewardTotal = data.total || 0
        this.rewardLoaded = true
      } finally {
        this.rewardLoading = false
      }
    },
    searchReward() {
      this.rewardPage = 1
      this.fetchRewardList()
    },
    resetRewardQuery() {
      this.rewardQuery = defaultRewardQuery()
      this.rewardPage = 1
      this.fetchRewardList()
    },
    onRewardSizeChange(size) {
      this.rewardPageSize = size
      this.rewardPage = 1
      this.fetchRewardList()
    },
    auditReward(row, passed) {
      const title = passed ? '审核通过' : '审核拒绝'
      const content = passed ? '审核通过后，该笔奖励将进入发放流程。' : '审核拒绝后，该笔奖励将不再发放。'
      const confirmButtonText = passed ? '确认通过' : '确认拒绝'
      this.$confirm(content, `确认${title}吗？`, {
        type: passed ? 'success' : 'warning',
        confirmButtonText,
        cancelButtonText: '取消',
      }).then(() => {
        const action = passed ? api.rewardAuditPass(row.id) : api.rewardAuditReject(row.id)
        action.then(() => {
          this.$message.success(`${title}成功`)
          this.fetchRewardList()
        })
      }).catch(() => {})
    },
    regrantReward(row) {
      this.$confirm('重新发放后，该笔奖励将重新进入定时任务处理。', '确认重新发放吗？', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        api.rewardRegrant(row.id).then(() => {
          this.$message.success('重新发放已提交')
          this.fetchRewardList()
        })
      }).catch(() => {})
    },
    showRewardActions(row) {
      return (this.canRewardAudit && row && row.status === 1)
        || (this.canRewardRegrant && row && row.status === 5)
    },
    buildStatsQuery() {
      const numericFields = [
        ['userId', '用户UID'],
        ['partnerUid', '合伙人UID'],
      ]
      for (const [field, label] of numericFields) {
        if (this.statsQuery[field] && !/^\d+$/.test(String(this.statsQuery[field]))) {
          this.$message.error(`${label}仅支持数字`)
          return null
        }
      }
      const params = {
        page: this.statsPage,
        size: this.statsPageSize,
        userId: this.statsQuery.userId,
        partnerUid: this.statsQuery.partnerUid,
        activityName: this.statsQuery.activityName,
        isPartner: this.statsQuery.isPartner,
        bonusLevel: this.statsQuery.bonusLevel,
        sortField: this.statsSortField,
        sortOrder: this.statsSortOrder,
      }
      if (this.statsQuery.timeRange && this.statsQuery.timeRange.length === 2) {
        params.startTime = this.statsQuery.timeRange[0]
        params.endTime = this.statsQuery.timeRange[1]
      }
      return params
    },
    async fetchStatsList() {
      const params = this.buildStatsQuery()
      if (!params) return
      this.statsLoading = true
      try {
        const res = await api.statisticsPage(params)
        const data = (res && res.data) || {}
        this.statsRows = data.items || []
        this.statsTotal = data.total || 0
        this.statsLoaded = true
      } finally {
        this.statsLoading = false
      }
    },
    async exportStats() {
      const params = this.buildStatsQuery()
      if (!params) return
      delete params.page
      delete params.size
      this.statsExporting = true
      try {
        const res = await api.statisticsExport(params)
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = '盈加码活动数据统计.xls'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      } finally {
        this.statsExporting = false
      }
    },
    async fetchBonusLevelOptions() {
      const res = await api.statisticsBonusLevels()
      const levels = ((res && res.data) || [])
        .map((level) => Number(level))
        .filter((level) => Number.isInteger(level) && level >= 0)
        .sort((a, b) => a - b)
      this.bonusLevelOptions = [...new Set(levels)].map((level) => ({
        label: `等级${level}`,
        value: level,
      }))
    },
    searchStats() {
      this.statsPage = 1
      this.fetchStatsList()
    },
    resetStatsQuery() {
      this.statsQuery = defaultStatsQuery()
      this.statsSortField = ''
      this.statsSortOrder = ''
      this.statsPage = 1
      this.fetchStatsList()
    },
    onStatsSizeChange(size) {
      this.statsPageSize = size
      this.statsPage = 1
      this.fetchStatsList()
    },
    onStatsSortChange({ prop, order }) {
      this.statsSortField = order ? prop : ''
      this.statsSortOrder = order || ''
      this.statsPage = 1
      this.fetchStatsList()
    },
    openBaseRateRecords(row) {
      this.currentStatsRow = row
      this.baseRateRecordVisible = true
      this.baseRateRecordPage = 1
      this.fetchBaseRateRecords()
    },
    async fetchBaseRateRecords() {
      if (!this.currentStatsRow) return
      this.baseRateRecordLoading = true
      try {
        const res = await api.statisticsBaseRateRecords({
          userId: this.currentStatsRow.userId,
          profitBonusActivityId: this.currentStatsRow.profitBonusActivityId,
          page: this.baseRateRecordPage,
          size: this.baseRateRecordPageSize,
        })
        const data = (res && res.data) || {}
        this.baseRateRecordRows = data.items || []
        this.baseRateRecordTotal = data.total || 0
      } finally {
        this.baseRateRecordLoading = false
      }
    },
    onBaseRateRecordSizeChange(size) {
      this.baseRateRecordPageSize = size
      this.baseRateRecordPage = 1
      this.fetchBaseRateRecords()
    },
    resetBaseRateRecordState() {
      this.currentStatsRow = null
      this.baseRateRecordRows = []
      this.baseRateRecordTotal = 0
      this.baseRateRecordPage = 1
    },
    openTaskRateRecords(row) {
      this.currentStatsRow = row
      this.taskRateRecordVisible = true
      this.taskRateRecordPage = 1
      this.fetchTaskRateRecords()
    },
    async fetchTaskRateRecords() {
      if (!this.currentStatsRow) return
      this.taskRateRecordLoading = true
      try {
        const res = await api.statisticsTaskRateRecords({
          userId: this.currentStatsRow.userId,
          profitBonusActivityId: this.currentStatsRow.profitBonusActivityId,
          page: this.taskRateRecordPage,
          size: this.taskRateRecordPageSize,
        })
        const data = (res && res.data) || {}
        this.taskRateRecordRows = data.items || []
        this.taskRateRecordTotal = data.total || 0
      } finally {
        this.taskRateRecordLoading = false
      }
    },
    onTaskRateRecordSizeChange(size) {
      this.taskRateRecordPageSize = size
      this.taskRateRecordPage = 1
      this.fetchTaskRateRecords()
    },
    resetTaskRateRecordState() {
      this.currentStatsRow = null
      this.taskRateRecordRows = []
      this.taskRateRecordTotal = 0
      this.taskRateRecordPage = 1
    },
    openRewardStatisticRecords(row, todayOnly) {
      this.currentStatsRow = row
      this.rewardStatisticVisible = true
      const today = this.beijingDateText(Date.now())
      this.rewardStatisticQuery.timeRange = todayOnly ? [today, today] : []
      this.rewardStatisticPage = 1
      this.fetchRewardStatisticRecords()
    },
    async fetchRewardStatisticRecords() {
      if (!this.currentStatsRow) return
      const params = {
        userId: this.currentStatsRow.userId,
        profitBonusActivityId: this.currentStatsRow.profitBonusActivityId,
        page: this.rewardStatisticPage,
        size: this.rewardStatisticPageSize,
      }
      if (this.rewardStatisticQuery.timeRange && this.rewardStatisticQuery.timeRange.length === 2) {
        params.startTime = this.beijingStartOfDay(this.rewardStatisticQuery.timeRange[0])
        params.endTime = this.beijingEndOfDay(this.rewardStatisticQuery.timeRange[1]) + 999
      }
      this.rewardStatisticLoading = true
      try {
        const res = await api.statisticsRewardRecords(params)
        const data = (res && res.data) || {}
        this.rewardStatisticRows = data.items || []
        this.rewardStatisticTotal = data.total || 0
        this.rewardStatisticTotalReward = data.totalReward || 0
      } finally {
        this.rewardStatisticLoading = false
      }
    },
    searchRewardStatisticRecords() {
      this.rewardStatisticPage = 1
      this.fetchRewardStatisticRecords()
    },
    resetRewardStatisticQuery() {
      this.rewardStatisticQuery.timeRange = []
      this.rewardStatisticPage = 1
      this.fetchRewardStatisticRecords()
    },
    onRewardStatisticSizeChange(size) {
      this.rewardStatisticPageSize = size
      this.rewardStatisticPage = 1
      this.fetchRewardStatisticRecords()
    },
    resetRewardStatisticState() {
      this.currentStatsRow = null
      this.rewardStatisticQuery.timeRange = []
      this.rewardStatisticRows = []
      this.rewardStatisticTotal = 0
      this.rewardStatisticTotalReward = 0
      this.rewardStatisticPage = 1
    },
    async openAdd() {
      if (this.addDisabledReason) {
        this.$message.error(this.addDisabledReason)
        return
      }
      await this.loadOptions()
      const first = this.firstVipValue()
      this.form = this.defaultForm()
      this.form.levels = [this.newLevel(0, first)]
      this.submitting = false
      this.resetActivityValidationState()
      this.dialogMode = 'add'
      this.dialogVisible = true
    },
    async openEdit(row) {
      await this.loadOptions()
      const res = await api.detail(row.id)
      this.fillForm((res && res.data) || {})
      this.submitting = false
      this.resetActivityValidationState()
      this.dialogMode = 'edit'
      this.dialogVisible = true
    },
    async openCopy(row) {
      if (this.addDisabledReason) {
        this.$message.error(this.addDisabledReason)
        return
      }
      await this.loadOptions()
      const res = await api.detail(row.id)
      this.fillForm((res && res.data) || {})
      this.form.id = null
      this.submitting = false
      this.resetActivityValidationState()
      this.dialogMode = 'copy'
      this.dialogVisible = true
    },
    async openDetail(row) {
      await this.loadOptions()
      const res = await api.detail(row.id)
      this.fillForm((res && res.data) || {})
      this.submitting = false
      this.resetActivityValidationState()
      this.dialogMode = 'detail'
      this.dialogVisible = true
    },
    fillForm(data) {
      const symbolIds = data.symbolIds || []
      this.form = {
        id: data.id,
        activityName: data.activityName || '',
        welfareUserTypeId: data.welfareUserTypeId || '',
        symbolScope: symbolIds.length ? 'PART' : 'ALL',
        symbolIds,
        participationType: 1,
        timeRange: [this.beijingDateText(data.startTime), this.beijingDateText(data.endTime)].filter(Boolean),
        totalQuota: this.rawText(data.totalQuota),
        settlementType: 1,
        settlementCycle: 1,
        approvalThreshold: this.rawText(data.approvalThreshold),
        bonusType: 1,
        assetStatCycle: data.assetStatCycle || '',
        tradeStatCycle: data.tradeStatCycle || '',
        levels: (data.levels || []).map((item) => ({
          bonusLevel: item.bonusLevel,
          vipLevelMin: item.vipLevelMin,
          vipLevelMax: item.vipLevelMax,
          assetThreshold: this.emptyZero(item.assetThreshold),
          tradeThreshold: this.emptyZero(item.tradeThreshold),
          bonusRate: this.rawText(item.bonusRate),
          quotaCycle: 1,
          quota: this.rawText(item.quota),
        })),
      }
      if (!this.form.levels.length) {
        this.form.levels = [this.newLevel(0, this.firstVipValue())]
      }
    },
    submitForm() {
      this.activityShowErrors = true
      if (!this.formValid) {
        this.$message.error(this.formInvalidReason || '请完善活动配置')
        return
      }
      const activityTimeRange = this.activityTimePayload()
      const payload = {
        id: this.form.id,
        activityName: this.form.activityName,
        welfareUserTypeId: this.form.welfareUserTypeId,
        symbolIds: this.form.symbolScope === 'PART' ? this.form.symbolIds : [],
        participationType: 1,
        totalQuota: this.form.totalQuota,
        settlementType: 1,
        settlementCycle: 1,
        approvalThreshold: this.form.approvalThreshold,
        bonusType: 1,
        assetStatCycle: this.form.assetStatCycle,
        tradeStatCycle: this.form.tradeStatCycle,
        startTime: activityTimeRange[0],
        endTime: activityTimeRange[1],
        levels: this.form.levels.map((row) => ({
          bonusLevel: row.bonusLevel,
          vipLevelMin: row.vipLevelMin,
          vipLevelMax: row.vipLevelMax,
          assetThreshold: this.optionalNumber(row.assetThreshold),
          tradeThreshold: this.optionalNumber(row.tradeThreshold),
          bonusRate: row.bonusRate,
          quotaCycle: 1,
          quota: row.quota,
        })),
      }
      const action = this.dialogMode === 'edit' ? api.update(payload) : api.add(payload)
      this.submitting = true
      action.then(() => {
        this.$message.success(this.dialogMode === 'edit' ? '编辑成功' : '新增成功')
        this.dialogVisible = false
        this.fetchList()
      }).finally(() => {
        this.submitting = false
      })
    },
    async manualActivityAction(row, action) {
      if (this.manualActionId !== null) return
      const actions = {
        startNow: {
          title: '立即开启',
          message: '将活动及其所有待开始任务的开始时间调整为北京时间今天00:00:00，并立即开启，结束时间保持不变。确认继续？',
          success: '立即开启成功',
        },
        endNow: {
          title: '立即结束',
          message: '将立即结束该活动及其所有未结束任务，并停用额度美化，配置的结束时间保持不变。确认继续？',
          success: '立即结束成功',
        },
        runNow: {
          title: '立即跑批',
          message: '将使用当前VIP等级和截至昨天的统计数据，重新统计该活动的用户等级、比例，并按原规则刷新可用额度。重复执行也会刷新额度。确认继续？',
          success: '已提交跑批',
        },
      }
      const config = actions[action]
      if (!config) return
      try {
        await this.$confirm(config.message, config.title, {
          type: 'warning', confirmButtonText: '确认', cancelButtonText: '取消',
        })
      } catch (_) {
        return
      }
      if (this.manualActionId !== null) return
      this.manualActionId = row.id
      this.manualAction = action
      try {
        await api[action](row.id)
        this.$message.success(config.success)
        this.taskLoaded = false
        this.statsLoaded = false
        this.fetchList()
      } catch (_) {
        // The shared HTTP interceptor displays API errors.
      } finally {
        this.manualActionId = null
        this.manualAction = ''
      }
    },
    toggleStatus(row, status) {
      const text = status === 2 ? '暂停' : '启用'
      this.$confirm(`确认${text}该活动？`, '提示', { type: 'warning' }).then(() => {
        api.status(row.id, status).then(() => {
          this.$message.success(`${text}成功`)
          this.fetchList()
        })
      })
    },
    addLevel() {
      if (this.form.levels.length >= 16) {
        this.$message.error('加成等级最多支持16条')
        return
      }
      const last = this.form.levels[this.form.levels.length - 1]
      const lastError = this.firstLevelErrorText(last, this.form.levels.length - 1)
      if (lastError) {
        this.activityLevelErrorIndexes = [this.form.levels.length - 1]
        this.$message.error(lastError)
        return
      }
      const nextVip = this.nextVipValue(last)
      if (nextVip === null) {
        this.$message.error('VIP等级已覆盖到最高等级，不能继续新增')
        return
      }
      this.form.levels.push(this.newLevel(this.form.levels.length, nextVip))
      this.activityLevelErrorIndexes = []
    },
    removeLevel(index) {
      if (index === 0) return
      this.form.levels.splice(index, 1)
      this.form.levels.forEach((row, rowIndex) => {
        row.bonusLevel = rowIndex
      })
      this.syncVipRanges(Math.max(0, index - 1))
    },
    syncVipRanges(index) {
      for (let i = index + 1; i < this.form.levels.length; i++) {
        const prev = this.form.levels[i - 1]
        const nextMin = Number(prev.vipLevelMax) + 1
        this.form.levels[i].vipLevelMin = nextMin
        if (Number(this.form.levels[i].vipLevelMax) < nextMin) {
          this.form.levels[i].vipLevelMax = nextMin
        }
      }
    },
    levelEndOptions(row) {
      return this.vipLevels.filter((item) => Number(item.code) >= Number(row.vipLevelMin))
    },
    nextVipValue(row) {
      const next = Number(row.vipLevelMax) + 1
      return this.vipLevels.some((item) => Number(item.code) === next) ? next : null
    },
    firstVipValue() {
      if (!this.vipLevels.length) return 0
      return Number(this.vipLevels[0].code)
    },
    collectFormErrors() {
      const errors = { levels: [], first: '' }
      const set = (field, message) => {
        if (!message) return
        errors[field] = message
        if (!errors.first) errors.first = message
      }
      const name = String(this.form.activityName || '').trim()
      if (!name) {
        set('activityName', '请填写活动名称')
      } else if (name.length > 50) {
        set('activityName', '活动名称最多50个字符')
      }
      if (!this.form.welfareUserTypeId) set('welfareUserTypeId', '请选择用户类别')
      if (this.form.symbolScope === 'PART' && (!this.form.symbolIds || !this.form.symbolIds.length)) {
        set('symbolIds', '请选择币对')
      }
      const range = this.form.timeRange || []
      if (range.length !== 2) {
        set('timeRange', '请选择活动时间')
      } else if (!this.beijingStartOfDay(range[0]) || !this.beijingEndOfDay(range[1])) {
        set('timeRange', '活动时间格式不正确')
      } else if (this.beijingStartOfDay(range[0]) < this.beijingTomorrowStart()) {
        set('timeRange', '活动开始时间只能选择北京时间明天及之后')
      } else if (this.beijingEndOfDay(range[1]) <= this.beijingStartOfDay(range[0])) {
        set('timeRange', '活动结束时间必须大于活动开始时间')
      }
      set('totalQuota', this.positiveIntegerError(this.form.totalQuota, 15, '总额度'))
      set('approvalThreshold', this.positiveIntegerError(this.form.approvalThreshold, 10, '奖励审核门槛'))
      if (!this.form.assetStatCycle) set('assetStatCycle', '请选择账户资产统计区间')
      if (!this.form.tradeStatCycle) set('tradeStatCycle', '请选择交易统计区间')
      if (!this.form.levels.length) {
        set('levels', '请配置加成等级')
      } else {
        this.form.levels.forEach((row, index) => {
          const levelErrors = this.buildLevelErrors(row, index)
          errors.levels[index] = levelErrors
          const firstLevel = this.firstErrorFrom(levelErrors)
          if (firstLevel && !errors.first) errors.first = firstLevel
        })
      }
      return errors
    },
    fieldError(field) {
      if (this.isDetail || !this.dialogVisible) return ''
      if (!this.activityShowErrors) return ''
      return this.formErrors[field] || ''
    },
    levelFieldError(index, field) {
      if (this.isDetail || !this.dialogVisible) return ''
      if (!this.activityShowErrors && !this.activityLevelErrorIndexes.includes(index)) return ''
      const rowErrors = this.formErrors.levels[index] || {}
      return rowErrors[field] || ''
    },
    resetActivityValidationState() {
      this.activityShowErrors = false
      this.activityLevelErrorIndexes = []
    },
    buildLevelErrors(row, index) {
      const errors = {}
      const prefix = `第${index + 1}行`
      const previousRow = this.form.levels[index - 1]
      if (!row || row.vipLevelMin === null || row.vipLevelMin === undefined || row.vipLevelMax === null || row.vipLevelMax === undefined) {
        errors.vipLevel = `${prefix}VIP等级区间不能为空`
      } else if (Number(row.vipLevelMax) < Number(row.vipLevelMin)) {
        errors.vipLevel = `${prefix}VIP结束等级不能小于开始等级`
      }
      const assetError = this.optionalPositiveIntegerError(row && row.assetThreshold, 15, `${prefix}账户资产门槛`)
      if (assetError) errors.assetThreshold = assetError
      if (!errors.assetThreshold && this.previousOptionalIntegerConfigured(previousRow, 'assetThreshold', 15)) {
        if (!this.nonEmpty(row && row.assetThreshold) || Number(row.assetThreshold) < Number(previousRow.assetThreshold)) {
          errors.assetThreshold = `${prefix}账户资产门槛不能小于前一等级`
        }
      }
      const tradeError = this.optionalPositiveIntegerError(row && row.tradeThreshold, 15, `${prefix}交易量门槛`)
      if (tradeError) errors.tradeThreshold = tradeError
      if (!errors.tradeThreshold && this.previousOptionalIntegerConfigured(previousRow, 'tradeThreshold', 15)) {
        if (!this.nonEmpty(row && row.tradeThreshold) || Number(row.tradeThreshold) < Number(previousRow.tradeThreshold)) {
          errors.tradeThreshold = `${prefix}交易量门槛不能小于前一等级`
        }
      }
      const rateError = this.percentError(row && row.bonusRate, `${prefix}加成比例`)
      if (rateError) errors.bonusRate = rateError
      if (!errors.bonusRate && previousRow && this.percent(previousRow.bonusRate)
        && Number(row.bonusRate) < Number(previousRow.bonusRate)) {
        errors.bonusRate = `${prefix}加成比例不能小于前一等级`
      }
      const quotaError = this.positiveIntegerError(row && row.quota, 15, `${prefix}额度数值`)
      if (quotaError) errors.quota = quotaError
      if (!errors.quota && previousRow && this.positiveInteger(previousRow.quota, 15)
        && Number(row.quota) < Number(previousRow.quota)) {
        errors.quota = `${prefix}额度数值不能小于前一等级`
      }
      return errors
    },
    firstLevelErrorText(row, index) {
      return this.firstErrorFrom(this.buildLevelErrors(row, index))
    },
    firstErrorFrom(errors) {
      const fields = ['vipLevel', 'assetThreshold', 'tradeThreshold', 'bonusRate', 'quota']
      const key = fields.find((field) => errors[field])
      return key ? errors[key] : ''
    },
    nonEmpty(value) {
      return value !== null && value !== undefined && String(value).trim() !== ''
    },
    previousOptionalIntegerConfigured(row, field, maxDigits) {
      return row && this.nonEmpty(row[field]) && this.positiveInteger(row[field], maxDigits)
    },
    activityTimePayload() {
      const range = this.form.timeRange || []
      return [
        this.beijingStartOfDay(range[0]),
        this.beijingEndOfDay(range[1]),
      ]
    },
    beijingTomorrowStart() {
      const today = this.beijingDateText(Date.now())
      return this.beijingStartOfDay(today) + 24 * 60 * 60 * 1000
    },
    beijingTomorrowDateText() {
      return this.beijingDateText(this.beijingTomorrowStart())
    },
    beijingStartOfDay(value) {
      return this.beijingBoundary(value, 0, 0, 0)
    },
    beijingEndOfDay(value) {
      return this.beijingBoundary(value, 23, 59, 59)
    },
    beijingBoundary(value, hour, minute, second) {
      if (!value) return null
      const parts = String(value).split('-').map((item) => Number(item))
      if (parts.length !== 3 || parts.some((item) => !Number.isInteger(item))) return null
      const [year, month, day] = parts
      return Date.UTC(year, month - 1, day, hour, minute, second, 0) - 8 * 60 * 60 * 1000
    },
    beijingDateText(value) {
      if (value === null || value === undefined || value === '') return ''
      const date = new Date(Number(value) + 8 * 60 * 60 * 1000)
      if (Number.isNaN(date.getTime())) return ''
      return `${date.getUTCFullYear()}-${this.padDate(date.getUTCMonth() + 1)}-${this.padDate(date.getUTCDate())}`
    },
    localDateText(date) {
      return `${date.getFullYear()}-${this.padDate(date.getMonth() + 1)}-${this.padDate(date.getDate())}`
    },
    padDate(value) {
      return String(value).padStart(2, '0')
    },
    onFormIntegerInput(field, value, maxDigits) {
      this.form[field] = this.sanitizeIntegerInput(value, maxDigits)
    },
    onLevelIntegerInput(row, field, value, maxDigits) {
      row[field] = this.sanitizeIntegerInput(value, maxDigits)
    },
    onLevelDecimalInput(row, field, value, maxDecimalPlaces) {
      row[field] = this.sanitizeDecimalInput(value, maxDecimalPlaces)
    },
    sanitizeIntegerInput(value, maxDigits) {
      return String(value == null ? '' : value).replace(/\D/g, '').slice(0, maxDigits)
    },
    sanitizeDecimalInput(value, maxDecimalPlaces) {
      const text = String(value == null ? '' : value).replace(/[^\d.]/g, '')
      const dotIndex = text.indexOf('.')
      if (dotIndex < 0) return text
      const integerPart = text.slice(0, dotIndex) || '0'
      const decimalPart = text.slice(dotIndex + 1).replace(/\./g, '').slice(0, maxDecimalPlaces)
      return `${integerPart}.${decimalPart}`
    },
    positiveIntegerError(value, maxDigits, fieldName) {
      if (!this.nonEmpty(value)) return `${fieldName}不能为空`
      return this.positiveInteger(value, maxDigits) ? '' : `${fieldName}仅支持1-${maxDigits}位正整数`
    },
    optionalPositiveIntegerError(value, maxDigits, fieldName) {
      if (!this.nonEmpty(value)) return ''
      return this.positiveInteger(value, maxDigits) ? '' : `${fieldName}仅支持1-${maxDigits}位正整数`
    },
    percentError(value, fieldName) {
      if (!this.nonEmpty(value)) return `${fieldName}不能为空`
      return this.percent(value) ? '' : `${fieldName}最多支持两位小数且不能小于0`
    },
    positiveInteger(value, maxDigits) {
      if (!this.nonEmpty(value)) return false
      const text = String(value)
      return new RegExp(`^[1-9]\\d{0,${maxDigits - 1}}$`).test(text)
    },
    percent(value) {
      if (!this.nonEmpty(value)) return false
      return /^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value))
    },
    optionalNumber(value) {
      return this.nonEmpty(value) ? value : null
    },
    rawText(value) {
      if (value === null || value === undefined) return ''
      return String(value)
    },
    emptyZero(value) {
      if (value === null || value === undefined || Number(value) === 0) return ''
      return String(value)
    },
    amountText(value) {
      if (value === null || value === undefined || value === '') return '-'
      return `${value} USDT`
    },
    levelText(value) {
      if (value === null || value === undefined || value === '') return '-'
      return `等级${value}`
    },
    vipText(value) {
      if (value === null || value === undefined || value === '') return '-'
      return `VIP ${value}`
    },
    statisticAmountText(value, days) {
      if (!days || value === null || value === undefined || value === '') return '--'
      return `近${days}天：${this.amountText(value)}`
    },
    matchedThresholdText(row) {
      if (!row) return '--'
      const labels = {
        VIP: 'VIP门槛',
        ASSET: '账户资产门槛',
        TRADE: '交易门槛',
      }
      const label = labels[row.changeSource]
      if (!label) return '--'
      const threshold = this.nonEmpty(row.matchedThreshold) ? row.matchedThreshold : '--'
      const snapshot = this.nonEmpty(row.actualValue) ? row.actualValue : '--'
      return `${label}=${threshold}\n达标快照=${snapshot}`
    },
    actualRewardText(row) {
      if (!row || row.status !== 4) return '--'
      return this.amountText(row.actualReward)
    },
    percentText(value) {
      if (value === null || value === undefined || value === '') return '-'
      const number = Number(value)
      if (Number.isNaN(number)) return '-'
      return `${(number * 100).toFixed(2).replace(/\.?0+$/, '')}%`
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const d = new Date(Number(timestamp) + 8 * 60 * 60 * 1000)
      if (Number.isNaN(d.getTime())) return '-'
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`
    },
    statusTagType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'warning'
      if (status === 3) return 'info'
      return ''
    },
    taskStatusTagType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'info'
      return ''
    },
    inviteStatusTagType(status) {
      if (status === 4) return 'success'
      if (status === 2 || status === 3) return 'warning'
      return ''
    },
    rewardStatusTagType(status) {
      if (status === 1) return 'warning'
      if (status === 3) return 'info'
      if (status === 4) return 'success'
      if (status === 5) return 'danger'
      return ''
    },
    copyLink(text) {
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$message.success('复制成功'))
        return
      }
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
  },
}
</script>

<style lang="less" scoped>
.profit-bonus-page {
  padding: 24px;
  background: #fff;

  .page-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
  }

  .title-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .title-bar {
    display: inline-block;
    width: 4px;
    height: 24px;
    border-radius: 2px;
    background: #1f6bff;
  }

  .page-title {
    color: #14265c;
    font-size: 20px;
    font-weight: 600;
  }

  .activity-tabs {
    margin-bottom: 22px;
  }

  .query-form {
    margin-bottom: 18px;
  }

  .management-query-form {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .management-add-item {
      margin-left: auto;
      margin-right: 0;
    }
  }

  .manual-activity-actions {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;

    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .activity-table {
    width: 100%;
  }

  .matched-threshold {
    white-space: pre-line;
    overflow-wrap: anywhere;
  }

  .pager {
    margin-top: 20px;
    text-align: right;
  }

  .link-text {
    color: #1f6bff;
    word-break: break-all;
  }

  .add-button-wrap {
    display: inline-block;
  }

  .danger-text {
    color: #f56c6c;
  }

  .empty-action {
    color: #8a98b3;
  }

  .reward-query-form {
    /deep/ .el-form-item {
      margin-right: 14px;
    }
  }

  .stats-query-form {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;

    /deep/ .el-form-item {
      margin-right: 12px;
    }

    .stats-input-item {
      flex: 0 0 150px;
    }

    .stats-select-item {
      flex: 0 0 126px;
    }

    .stats-time-item {
      flex: 0 0 360px;
    }

    .stats-action-item {
      flex: 0 0 auto;
      margin-right: 0;
      white-space: nowrap;
    }

    /deep/ .stats-input-item .el-input,
    /deep/ .stats-select-item .el-select {
      width: 100%;
    }

    /deep/ .stats-time-item .el-date-editor {
      width: 360px;
    }
  }
}

.profit-dialog {
  /deep/ .el-dialog__header {
    padding: 18px 24px 8px;
  }

  /deep/ .el-dialog__body {
    padding: 14px 24px 8px;
  }

  /deep/ .el-dialog__footer {
    padding: 12px 24px 16px;
    border-top: 1px solid #edf1f7;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    /deep/ .el-button + .el-button {
      margin-left: 0;
    }
  }

  .dialog-body {
    max-height: 74vh;
    padding-right: 6px;
    overflow-y: auto;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin: 2px 0 10px;
    color: #0f2454;
    font-size: 14px;
    font-weight: 600;

    span {
      display: inline-block;
      width: 4px;
      height: 18px;
      margin-right: 8px;
      border-radius: 2px;
      background: #1f6bff;
    }
  }

  .form-grid {
    display: grid;
    gap: 10px 28px;

    &.two {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    &.three {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  .el-select,
  .el-date-editor {
    width: 100%;
  }

  /deep/ .el-form-item {
    margin-bottom: 12px;
  }

  /deep/ .el-form-item__label {
    padding-bottom: 4px;
    color: #253858;
    font-weight: 500;
    line-height: 20px;
  }

  /deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    color: #f56c6c;
  }

  /deep/ .el-input.is-disabled .el-input__inner,
  /deep/ .el-textarea.is-disabled .el-textarea__inner,
  /deep/ .el-select .el-input.is-disabled .el-input__inner {
    color: #31456f;
    background-color: #f7f9fc;
    border-color: #d6deee;
    cursor: not-allowed;
  }

  /deep/ .el-input.is-disabled .el-input__inner::placeholder,
  /deep/ .el-textarea.is-disabled .el-textarea__inner::placeholder {
    color: #8a98b3;
  }

  /deep/ .el-input-group__append {
    min-width: 44px;
    padding: 0 8px;
    color: #536683;
    background: #f4f7fb;
    border-color: #d6deee;
  }

  .symbol-select {
    /deep/ .el-select__tags {
      max-width: calc(100% - 34px) !important;
      line-height: 24px;
      white-space: normal;
    }

    /deep/ .el-tag {
      margin: 2px 4px 2px 0;
    }
  }

  .level-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
    margin-bottom: 12px;
  }

  .level-title {
    margin-bottom: 0;
  }

  .level-table {
    width: 100%;

    /deep/ .el-table__header,
    /deep/ .el-table__body {
      width: 100% !important;
    }

    /deep/ .el-table__header-wrapper,
    /deep/ .el-table__body-wrapper {
      overflow-x: hidden !important;
    }

    /deep/ .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 32px;
      padding-right: 6px;
      padding-left: 6px;
      overflow: visible;
    }

    .level-form-item {
      width: 100%;
      margin-bottom: 0;

      /deep/ .el-form-item__content {
        line-height: 28px;
      }

      /deep/ .el-form-item__error {
        position: static;
        width: 100%;
        padding-top: 2px;
        line-height: 13px;
        white-space: normal;
        text-align: left;
      }
    }

    .unit-input {
      /deep/ .el-input-group__append {
        min-width: 34px;
      }
    }

    .rate-input {
      /deep/ .el-input-group__append {
        min-width: 16px;
      }
    }

    .vip-range {
      display: grid;
      grid-template-columns: minmax(68px, 1fr) 20px minmax(68px, 1fr);
      gap: 4px;
      align-items: center;
    }
  }

  .form-hint {
    margin-top: 10px;
    color: #8492c4;
    font-size: 12px;
  }
}
</style>
